import api from "./api";

// 权益新增
export const add = params => {
  return api("put", `/v1/management/benefits/add`, params);
};

// 权益删除
export const del = params => {
  return api("delete", `/v1/management/benefits/delete`, params);
};

// 权益下架
export const publish = params => {
  return api("post", `/v1/management/benefits/publish`, params);
};

// 权益下架
export const offShelf = params => {
  return api("post", `/v1/management/benefits/offShelf`, params);
};

// 权益查询
export const query = params => {
  return api("post", `/v1/management/benefits/query`, params);
};

// 权益查询
export const update = params => {
  return api("post", `/v1/management/benefits/update`, params);
};

// 修改特卖商城
export const updateStore = params => {
  return api("post", `/v1/management/benefits/updateStore`, params);
};
